<div #counterElement>
  {{ count | number:'1.0-0' }}
</div>
